module.exports = __webpack_public_path__ + "static/media/Transparente.a83639a9.pdf";